// extracted by mini-css-extract-plugin
export default {"menu":"_3AEMm","menu-item":"_2Wrxe","menuItem":"_2Wrxe"};